import { Injectable  } from '@angular/core';
import {Observable, BehaviorSubject } from 'rxjs';
// import { ThreeDotMenuElement } from '@core/classes/three-dot-menu-item.class';

@Injectable()
export class ThreeDotService {
  // Three dot interface listeners for action on menus to set when a menu is active,

  // Future improve, receive the menu, to get what key was activated
  private triggerMenuSubjects = new Map<string, BehaviorSubject<boolean>>();

  getTriggerObservable(menuIdentifier: string): Observable<boolean> {
    if (!this.triggerMenuSubjects.has(menuIdentifier)) {
      this.triggerMenuSubjects.set(menuIdentifier, new BehaviorSubject<boolean>(false));
    }
    return this.triggerMenuSubjects.get(menuIdentifier).asObservable();
  }

  setTriggered(menuIdentifier: string, active: boolean): void {
    if (!this.triggerMenuSubjects.has(menuIdentifier)) {
      this.triggerMenuSubjects.set(menuIdentifier, new BehaviorSubject<boolean>(active));
    } else {
      this.triggerMenuSubjects.get(menuIdentifier).next(active);
    }
  }

  resetAll(): void {
    this.triggerMenuSubjects.forEach((subject) => subject.next(false));
  }
}

